export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class Examinee {
  id: number
  student_no_character: string
  student_no: number
  student_name: string

  constructor(examinee: any){
    this.id = examinee.id;
    this.student_no_character = examinee.student_no_character;
    this.student_no = examinee.student_no;
    this.student_name = examinee.student_name;
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number | null
  score_cache: number | null
  correct_state: number | null
  correct_state_cache: number | null
  recog_text: string
  saiten_completed: boolean
  is_correct_changed: boolean
  is_correct_changed_cache: boolean
  sheetActivity: SheetActivity
  examinee: Examinee
  base64Image: string | null = null
  base64Canvas: string | null = null
  isCanvasEdited: boolean = false
  isTextEdited: boolean = false
  base64PreviewImages: string[] = []
  tensakuTexts: TensakuText[]
  tensakuTextIdx: number = 0
  
  constructor(fieldActiviby: any, sheetActivities: any[], examinees: any[], base64ImageHashArray: any[], base64CanvasHashArray: any[], page_count: number, tensaku_texts: any[]){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    // 未採点は○×順ソート用に-1を設定
    this.score = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.score_cache = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.correct_state_cache = fieldActiviby.correct_state;
    this.recog_text = fieldActiviby.recog_text;
    this.saiten_completed = fieldActiviby.saiten_completed;
    this.is_correct_changed = fieldActiviby.is_correct_changed;
    this.is_correct_changed_cache = fieldActiviby.is_correct_changed;
    this.sheetActivity = new SheetActivity(sheetActivities.filter((x: any) => x.id == this.sheet_activity_id)[0]);
    this.examinee = new Examinee(examinees.filter((x: any) => x.student_no == this.sheetActivity.student_id)[0]);
    const base64Image = base64ImageHashArray.filter(x => x.field_activity_id == this.id);
    
    this.tensakuTexts = tensaku_texts.filter((x: any) => x.field_activity_id == fieldActiviby.id).map((x: any) => {
      const tensakuText = new TensakuText();
      tensakuText.id = x.id;
      tensakuText.field_activity_id = x.field_activity_id;
      tensakuText.text = x.text;
      tensakuText.idx = this.tensakuTextIdx++;
      tensakuText.font_size = x.font_size;
      tensakuText.line_height = x.line_height;
      tensakuText.color = x.color;
      tensakuText.x = x.x;
      tensakuText.y = x.y;
      tensakuText.width = x.width;
      tensakuText.height = x.height;
      return tensakuText;
    });
    
    if(base64Image.length > 0){
      this.base64Image = base64Image[0].src;
    }
    const base64Canvas = base64CanvasHashArray.filter(x => x.field_activity_id == this.id);
    if(base64Canvas.length > 0){
      this.base64Canvas = base64Canvas[0].src;
    }
  }
}

export class ParamFieldActivity {
  id: number
  sheet_activity_id: number
  score: number | null
  correct_state: number | null
  is_correct_changed: boolean
  tensaku_texts: ParamTensakuText[] = []

  constructor(fieldActivity: FieldActivity){
    this.id = fieldActivity.id;
    this.sheet_activity_id = fieldActivity.sheet_activity_id;
    this.score = fieldActivity.score == -1 ? null : fieldActivity.score;
    this.correct_state = fieldActivity.correct_state;
    this.is_correct_changed = fieldActivity.is_correct_changed;
    this.tensaku_texts = fieldActivity.tensakuTexts.map(x => new ParamTensakuText(x));
  }
}

export class ParamTensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null

  constructor(x: TensakuText){
    this.id = x.id
    this.field_activity_id = x.field_activity_id
    this.idx = x.idx
    this.text = x.text
    this.color = x.color
    this.font_size = x.font_size
    this.line_height = x.line_height
    this.x = x.x
    this.y = x.y
    this.width = x.width
    this.height = x.height
  }
}

export class Sheet {
  id: number
  grade: number
  room_name: string
  name: string
  curriculum_id: number
  subject_name: string
  exec_date: string
  allot: number
  page_count: number
  result_published: boolean
  approval_flg: boolean
  created_by: string
  edit_lock: boolean
  verify_count: number
  is_mask_student_info: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.exec_date = sheet.exec_date;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.result_published = sheet.result_published;
    this.approval_flg = sheet.approval_flg;
    this.created_by = sheet.created_by;
    this.edit_lock = sheet.edit_lock;
    this.verify_count = sheet.verify_count;
    this.is_mask_student_info = sheet.is_mask_student_info;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  page: number
  scoreAverage: number
  scoreRate: number
  isSaitenCompleted: boolean
  baseWidth: number
  baseHeight: number
  addition: string
  first_scorers_id: string
  second_scorers_id: string
  third_scorers_id: string
  scoring_type: number

  constructor(sheetField: any, buffSize: number){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.page = sheetField.page;
    this.baseWidth = sheetField.rim[2] + (buffSize * 2);
    this.baseHeight = sheetField.rim[3] + (buffSize * 2);
    this.addition = sheetField.addition;
    this.first_scorers_id = sheetField.first_scorers_id;
    this.second_scorers_id = sheetField.second_scorers_id;
    this.third_scorers_id = sheetField.third_scorers_id;
    this.scoring_type = sheetField.scoring_type;
  }
}

export class TensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export const SaitenModeEnum = Object.freeze({
  None: 0,
  KeyInput: 1, 
  SeitouClick: 2, 
  GotouClick: 3, 
  TokutenClick: 4, 
  FreeLine: 5,
  StraightLine: 6,
  BracesStart: 7,
  BracesEnd: 8,
  Number: 9,
  Eraser: 10,
  Trash: 11,
});
export const CorrectStateEnum = Object.freeze({Seitou: 1, Gotou: -1, Tokuten: 0});
export const SortKindEnum = Object.freeze({No: 1, CorrectState: 2, FileSize: 3});
export const DirectionEnum = Object.freeze({Horizon: 1, Vertical: 2});